"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ChevronLeftIcon = _interopRequireDefault(require("../Icons/ChevronLeftIcon"));

var _ChevronRightIcon = _interopRequireDefault(require("../Icons/ChevronRightIcon"));

var _ChevronDownIcon = _interopRequireDefault(require("../Icons/ChevronDownIcon"));

var _ChevronUpIcon = _interopRequireDefault(require("../Icons/ChevronUpIcon"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * A Link anchor tag component.
 * http://nutanix.design/2.0/#Components_Links
 */
var Link =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, _getPrototypeOf(Link).apply(this, arguments));
  }

  _createClass(Link, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          size = _this$props.size,
          icon = _this$props.icon,
          expanded = _this$props.expanded,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          props = _objectWithoutProperties(_this$props, ["className", "type", "size", "icon", "expanded", "disabled", "onClick"]);

      var mergedClassName = (0, _classnames.default)("".concat(_ThemeManager.default.getVar('classPrefix'), "-link ").concat(_ThemeManager.default.getVar('classPrefix')), className, disabled ? 'disabled' : '');
      var linkNode;

      switch (type) {
        case 'backward':
          linkNode = _react.default.createElement(_FlexLayout.default, {
            alignItems: "center",
            itemSpacing: "10px",
            display: "inline-flex"
          }, _react.default.createElement(_ChevronLeftIcon.default, null), _react.default.createElement("span", null, this.props.children));
          break;

        case 'forward':
          linkNode = _react.default.createElement(_FlexLayout.default, {
            alignItems: "center",
            itemSpacing: "10px",
            display: "inline-flex"
          }, _react.default.createElement("span", null, this.props.children), _react.default.createElement(_ChevronRightIcon.default, null));
          break;

        case 'expandable':
          var chevronIcon = _react.default.createElement(_ChevronDownIcon.default, null);

          if (expanded) {
            chevronIcon = _react.default.createElement(_ChevronUpIcon.default, null);
          }

          linkNode = _react.default.createElement(_FlexLayout.default, {
            alignItems: "center",
            itemSpacing: "5px",
            display: "inline-flex"
          }, _react.default.createElement("span", null, this.props.children), chevronIcon);
          break;

        case 'with-icon':
        default:
          linkNode = _react.default.createElement(_FlexLayout.default, {
            alignItems: "center",
            itemSpacing: "10px",
            display: "inline-flex"
          }, icon, _react.default.createElement("span", null, this.props.children));
          break;
      }

      return _react.default.createElement("a", _extends({
        className: mergedClassName,
        "data-size": size,
        "data-type": type,
        onClick: disabled ? null : onClick
      }, props), linkNode);
    }
  }]);

  return Link;
}(_react.default.Component);

exports.default = Link;
Link.defaultProps = {
  type: 'primary',
  size: 'medium',
  disabled: false,
  onClick: null,
  icon: null,
  expanded: false
};
Link.propTypes = {
  /**
   * Additional class name.
   */
  className: _propTypes.default.string,

  /**
   * String link
   */
  children: _propTypes.default.node,

  /**
   * Link style type.  If using 'with-icon', then you will need to
   * provide props.icon: <XXXIcon />
   */
  type: _propTypes.default.oneOf(['primary', 'backward', 'delete', 'info', 'forward', 'expandable', 'with-icon']),

  /**
   * Size of Link.
   */
  size: _propTypes.default.oneOf(['small', 'medium']),

  /**
   * If props.type = 'with-icon' then this must contain an icon component
   */
  icon: _propTypes.default.element,

  /**
   * Disable the link.  Default is false.
   */
  disabled: _propTypes.default.bool,

  /**
   * Callback function to handle on click.
   */
  onClick: _propTypes.default.func,

  /**
   * On type = 'expandable', set this to true/false
   */
  expanded: _propTypes.default.bool
};